import { render, staticRenderFns } from "./PollPieChart.vue?vue&type=template&id=babb7d08&"
import script from "./PollPieChart.vue?vue&type=script&lang=ts&"
export * from "./PollPieChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports